import { render } from "./SystemAccessLogCard.vue?vue&type=template&id=703c64fd&scoped=true"
import script from "./SystemAccessLogCard.vue?vue&type=script&lang=js"
export * from "./SystemAccessLogCard.vue?vue&type=script&lang=js"

import "./SystemAccessLogCard.vue?vue&type=style&index=0&id=703c64fd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703c64fd"]])

export default __exports__